import { useQueryClient } from '@tanstack/react-query'

import { ClientError } from '@tribeplatform/gql-client/lib'
import {
  Chat,
  MutationLeaveGroupChatArgs,
} from '@tribeplatform/gql-client/types'

import {
  UseMutationOptions,
  useMutation,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getChatKey } from '../../utils/keys/index.js'

export const useLeaveGroupChat = (
  options?: UseMutationOptions<Chat, ClientError, MutationLeaveGroupChatArgs>,
) => {
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Chat, ClientError, MutationLeaveGroupChatArgs>(
    (input: MutationLeaveGroupChatArgs) =>
      client.messaging.leaveGroupChat(input),
    {
      ...(options ?? {}),
      onSuccess: async (data, variables, context) => {
        const chatKey = getChatKey({
          variables: { id: variables.chatId },
        })

        queryClient.invalidateQueries(chatKey)
        if (options?.onSuccess) {
          options.onSuccess(data, variables, context)
        }

        return data
      },
    },
  )
}
